module.exports = __webpack_public_path__ + "img/banner2x2.8fdc7fdb.png";